import { plazaSearchParams } from "./server/filters";
import type { PlazaFilters } from "./types";

export function plazaBrowseHref(filters: PlazaFilters, overrides: Partial<PlazaFilters> = {}, context: {
  basePath?: string;
  project?: { id: string; roleId: string };
  favoritesOnly?: boolean;
} = {}) {
  const params = new URLSearchParams(plazaSearchParams(filters, overrides).split("?")[1]);
  if (context.project) { params.set("project", context.project.id); params.set("role", context.project.roleId); }
  if (context.favoritesOnly) params.set("favorites", "true");
  const basePath = context.basePath ?? "/plaza";
  return params.size ? `${basePath}?${params}` : basePath;
}
